import React from 'react';
import { FaLock, FaEye, FaFileAlt, FaHandshake, FaBalanceScale, FaEnvelope } from 'react-icons/fa';

const HipaaMenu = ({ setStep }) => {
  const hipaaCategories = [
    {
      id: 'unauthorizedDisclosureForm',
      title: 'Unauthorized Disclosure',
      description: 'Accidental or intentional disclosure of PHI to unauthorized persons',
      Icon: FaLock,
      iconColor: 'text-violet-600'
    },
    {
      id: 'improperAccessForm',
      title: 'Improper Access',
      description: 'Staff accessing PHI without authorization or business need',
      Icon: FaEye,
      iconColor: 'text-violet-600'
    },
    {
      id: 'lostRecordsForm',
      title: 'Lost/Misplaced Records',
      description: 'Physical or electronic records containing PHI that are lost',
      Icon: FaFileAlt,
      iconColor: 'text-violet-600'
    },
    {
      id: 'vendorBreachForm',
      title: 'Vendor/BAA Breach',
      description: 'Business associate or vendor compromise involving PHI',
      Icon: FaHandshake,
      iconColor: 'text-violet-600'
    },
    {
      id: 'patientRightsForm',
      title: 'Patient Rights Violation',
      description: 'Failure to honor patient access, amendment, or restriction requests',
      Icon: FaBalanceScale,
      iconColor: 'text-violet-600'
    },
    {
      id: 'transmissionErrorForm',
      title: 'Transmission Error',
      description: 'PHI sent to wrong recipient via fax, email, or mail',
      Icon: FaEnvelope,
      iconColor: 'text-violet-600'
    }
  ];

  return (
    <div className="menu-screen">
      <h1 className="menu-heading">HIPAA Disclosure Report</h1>
      <p className="menu-sub">Select the category that best describes the HIPAA incident</p>
      
      <div className="menu-grid three-cols">
        {hipaaCategories.map((category) => {
          const IconComponent = category.Icon;
          return (
            <div
              key={category.id}
              className="menu-card hipaa"
              onClick={() => setStep(category.id)}
            >
              <div className="menu-icon" aria-hidden>
                <IconComponent className={`size-8 ${category.iconColor}`} />
              </div>
              <h3 className="menu-title">{category.title}</h3>
              <p className="menu-subtitle">{category.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HipaaMenu;
